import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Employee } from '@app/models/employee/employee.model';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { TaxCreditTableComponent, TaxCreditTableLoadEvent } from './tax-credit-table/tax-credit-table.component';

@Component({
    templateUrl: './tax-credit.template.html',
    styleUrls: ['./tax-credit.style.scss'],
    selector: 'app-tax-credit',
    standalone: true,
    imports: [TranslateModule, CommonModule, PlatformModule, TaxCreditTableComponent],
})
export class TaxCredit {
    @Output() onDataLoad: EventEmitter<TaxCreditTableLoadEvent> = new EventEmitter<TaxCreditTableLoadEvent>();

    @ViewChildren(TaxCreditTableComponent) set tables(tables: QueryList<TaxCreditTableComponent>) {
        this.numTables = tables.length;
    }

    employee!: Employee;

    // Keep track of the number of tables within the component so that we know once all of them have finished loading
    // This num is currently 2, but this allows flexibility in case this changes in the future
    private numTables = -1;
    private loadEvents: TaxCreditTableLoadEvent[] = [];

    constructor(private route: ActivatedRoute) {
        this.employee = this.route.snapshot.data.models.get('employee');
    }

    handleDataLoad(event: TaxCreditTableLoadEvent): void {
        this.loadEvents.push(event);
        // Once all tables have loaded we send one event that combines them all
        if (this.numTables === this.loadEvents.length) {
            this.onDataLoad.emit({ isEmpty: this.loadEvents.every((e) => e.isEmpty) });
        }
    }
}
